// src/pages/About.jsx
import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import AboutBanner from "../components/AboutBanner"; // banner we made
import AboutSection from "../components/AboutSection"; // your content

import Footer from "../components/Footer";
import TeamSection from "../components/TeamSection";
import MissionVisionValues from "../components/VisionMissionSection";

import ChooseUsSection from "../components/ChooseUsSection";


const About = () => {
  return (
    <>
      <CustomNavbar />
      <AboutBanner />
      <AboutSection />
      <MissionVisionValues/>
    <ChooseUsSection/>
      <TeamSection/>
      <Footer />
    </>
  );
};

export default About;
